import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })

  return {
    variables: {
      id: patient_id,
    },
    pause: !patient_id,
  }
}
